module.exports = __webpack_public_path__ + "fonts/check_ul-3.svg";